export enum ModalActionsEnum {
    Cancel = 'Cancel',
    CancelPrevious = 'CancelPrevious',
    Retry = 'Retry'
}
